import React from "react";
import styled from "styled-components";

const Title = styled.h2`
  font-family: 'Geist Variable', 'Geist', sans-serif;
  font-weight: 600;
  font-size: clamp(22px, 3.5vw, 28px);
  color: oklch(.145 0 0);
  margin: 0 0 14px 0;
`;

const Paragraph = styled.p`
  color: #4b5563;
  font-size: 14px;
  margin: 8px 0 0 0;
`;

export default function SubmissionComplete() {
  return (
    <div>
      <Title>Your actions have been submitted!</Title>
      <Paragraph>Next steps:</Paragraph>
      <ul style={{ marginTop: 6, color: '#4b5563', paddingLeft: 18 }}>
        <li>You will receive an email confirming your actions for your records</li>
        <li>You will receive email check-ins to track the progress of your actions </li>
        <li>You will receive check-ins to add action steps or modify these ones </li>
      </ul>
    </div>
  );
}

